/* Printer */
export const GET_PRINTER = 'GET_PRINTER';
export const PRINTER_RECEIVED = 'PRINTER_RECEIVED';
export const CREATE_PRINTER = 'CREATE_PRINTER';
export const PRINTER_CREATED = 'PRINTER_CREATED';
